"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVisit = void 0;
const context_1 = require("./context");
function createPostRequest(action, apiDomain, requestBody, successCallback, errorCallback, isFromWordPress) {
    const apiBase = isFromWordPress ? "visit/v1/wordpress" : "visit/v1";
    fetch(`${apiDomain}/${apiBase}/${action}/`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
        credentials: "include",
    })
        .then((response) => {
        if (!response.ok) {
            return response.text().then((errorText) => {
                throw new Error(errorText);
            });
        }
        return response.text();
    })
        .then((text) => {
        if (successCallback) {
            successCallback(text);
        }
    })
        .catch(function (error) {
        if (errorCallback) {
            errorCallback(error);
        }
    });
}
async function apiCreateVisit(apiDomain, requestBody, successCallback, errorCallback, isFromWordPress) {
    return createPostRequest("create", apiDomain, requestBody, successCallback, errorCallback, isFromWordPress);
}
async function apiUpdateVisit(apiDomain, requestBody, successCallback, errorCallback, isFromWordPress) {
    return createPostRequest("update", apiDomain, requestBody, successCallback, errorCallback, isFromWordPress);
}
function updateVisit(apiDomain, creating, urlParams, rawData = {}, successCallback, errorCallback, isFromWordPress) {
    const requestBody = {
        currentUrl: urlParams.initialUrl || document.URL,
        urlParams: JSON.stringify(urlParams),
        rawData: {
            country: context_1.getCountryCode(),
            subdivision: context_1.getSubdivision(),
            language: context_1.getLanguage(),
            route_id: context_1.getRouteId(),
            ...rawData,
        },
    };
    if (creating) {
        apiCreateVisit(apiDomain, requestBody, successCallback, errorCallback, isFromWordPress);
    }
    else {
        apiUpdateVisit(apiDomain, requestBody, successCallback, errorCallback, isFromWordPress);
    }
}
exports.updateVisit = updateVisit;
//# sourceMappingURL=api.js.map